import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.harvest-report-table', () => {
  void import('./internal/harvest-report-table').then(({ default: Component }) => Component());
});
